import { type EntityMember } from '@neptune/shared/entity-domain';

import { isCompareDataDTOBaseShape, isRecord } from './compare-data-utils';
import {
  type CompareDataDTOUpToV1,
  isSupportedCompareDataDTO as isSupportedPreviousCompareDataDTO,
} from './compare-data-v1';

const version = '2' as const;

export type CompareDataDTOV2 = {
  version: typeof version;
  workspaceName: string;
  projectIdentifier: string;
  compare: {
    runMembers: EntityMember[];
    experimentMembers: EntityMember[];
  };
};

export type CompareDataDTOUpToV2 = CompareDataDTOUpToV1 | CompareDataDTOV2;

export { version };

function isEntityMember(input: unknown): input is EntityMember {
  return isRecord(input) && typeof input.key === 'string' && typeof input.hidden === 'boolean';
}

function isEntityMemberArray(input: unknown): input is EntityMember[] {
  return Array.isArray(input) && input.every(isEntityMember);
}

export function isCompareDataDTO(input: unknown): input is CompareDataDTOV2 {
  return (
    isCompareDataDTOBaseShape(input) &&
    input.version === version &&
    isRecord(input.compare) &&
    isEntityMemberArray(input.compare.runMembers) &&
    isEntityMemberArray(input.compare.experimentMembers)
  );
}

export function isSupportedCompareDataDTO(input: unknown): input is CompareDataDTOUpToV2 {
  return isCompareDataDTO(input) || isSupportedPreviousCompareDataDTO(input);
}
